
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom";

import { IconButton, Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { MensajeAlertaDanger } from "../../components";

import { separadorMillares } from "../../../hooks/useMillares";

import { openModalAbonosOpCliente } from "../../../actions";
import { ModalAbonoOpCliente } from "./ModalAbonoOpCliente";
import { opStartActivo } from "../../../actions/op";
import { LayoutTabla } from "../../layouts";
import { useOpsStore } from "../../../stores";
import { useQueryClient } from "@tanstack/react-query";


import dayjs from "dayjs";


const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaOpsPorCliente = ({ data, chagePage=() => {}, page=0 }) => {


    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { totalOps } = useOpsStore();



    
    const handleOpcionesOp = (uid) => {
        navigate(`/super/detalles-op/${uid}`);
    }


    
    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalOps / +paginado)} disabled={Math.ceil(totalOps / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead >
                    <TableRow>
                        <TableCell sx={{width:'13%'}}>O.P.</TableCell>
                        <TableCell sx={{width:'15%'}}>COMPRA</TableCell>
                        <TableCell sx={{width:'15%'}}>TOTAL</TableCell>
                        <TableCell sx={{width:'15%'}}>ABONO</TableCell>
                        <TableCell sx={{width:'15%'}}>SALDO</TableCell>
                        <TableCell sx={{width:'15%'}}>PAGO</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data.map( (ops) => (
                    <TableRow key={ ops.id } onClick={ () => handleOpcionesOp(ops.id) } sx={{cursor:'pointer'}}>
                        <TableCell> { ops.op }</TableCell>
                        <TableCell>{ dayjs(ops.startOp).format('D MMM YYYY') }</TableCell>
                        <TableCell>{ `$${separadorMillares(ops.totalOrden)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(ops.totalOrden- ops.deudaAdmin)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(ops.deudaAdmin)}` }</TableCell>
                        <TableCell sx={{color:(ops.pago === 'PENDIENTE') ? 'red' : 'white'}}>
                            { ops.pago }
                        </TableCell>
                    </TableRow>
                    ))
                    }
                </TableBody>

            </LayoutTabla>


            :   <MensajeAlertaDanger titulo='No hay ops disponibles' />
        }
        </>

    )
}
